import React, { useState } from 'react';
import { initialSite, SiteContext } from './SiteContext';
import { Site } from '../components/common/CommonTypes';

type SiteProviderProps = {
  children: React.ReactNode;
};

const SiteProvider = ({ children }: SiteProviderProps): JSX.Element => {
  const [site, setSite] = useState<Site>(initialSite);

  return (
    <SiteContext.Provider
      value={{
        site,
        setSite
      }}>
      {children}
    </SiteContext.Provider>
  );
};

export default SiteProvider;
